var path = '/app/pages/account/change-password/account.change-password.html';
var html = "<dynamic-heading text=ctrl.heading></dynamic-heading> <hr> <div uib-alert ng-if=ctrl.Alerts.local.msg ng-class=\"'p-4 my-4 alert-' + (ctrl.Alerts.local.type || 'info')\">{{ ctrl.Alerts.local.msg }}</div> <dynamic-form ng-if=ctrl.formTemplate template=ctrl.formTemplate ng-model=ctrl.formTemplate.model></dynamic-form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/change-password/account.change-password.html
// module id = 418
// module chunks = 0